import React from 'react';

export default function HackingSectionContent7() {
    return (
        <React.Fragment>
            <>
                <section className>  <div className="container px-4 mx-auto mb-16 pt-20">    <div className="max-w-2xl mx-auto text-center">      <div className="flex mb-2 items-center justify-center"><a className="text-xs text-gray-200" href="#">Not Manifesto</a></div>      <h2 className="mb-6 text-4xl lg:text-5xl font-bold font-heading">不是宣言</h2>  </div></div>  <div className="container mx-auto">    </div></section>


            </>
        </React.Fragment>
    );
}

